namespace Rio.Enums {
    export enum EWatchTimetype {
        Unlimited = 0,
        LimitedPerContent = 1
    }
    Serenity.Decorators.registerEnumType(EWatchTimetype, 'Rio.Enums.EWatchTimetype');
}
